import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, Text, useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { adminCreateKeyword } from "../../../api";
import { colors } from "../../../styles";

interface CreateKeywordModalProps {
    isOpen : boolean;
    onClose : () => void;

    page: number;
    size: number;
    searchKeyword: string | null;
}

export default function CreateKeywordModal(props : CreateKeywordModalProps) {

    /* form */

    interface ICreateKeywordForm {
        keyword: string;
    }

    const { register, handleSubmit, formState: { errors, isValid } } = useForm<ICreateKeywordForm>({
        mode: "onChange",
    });

    /* onSubmit */

    const onSubmit = async (data: ICreateKeywordForm) => {
        await createKeywordMutation.mutateAsync({ keyword: data.keyword });
    }

    /* mutation */

    const queryClient = useQueryClient();

    const toast = useToast();

    const createKeywordMutation = useMutation({
        mutationFn: adminCreateKeyword,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['adminGetKeywords', props.page, props.size, props.searchKeyword] });
            queryClient.invalidateQueries({ queryKey: ['adminAutoCompleteKeyword'] });
            props.onClose();
        },
        onError: (error: any) => {
            toast({
                title: `${error.response?.data?.message}`,
                status: "error",
                position: "top",
                duration: 3000,
                isClosable: true,
            });
        },
    });

    /* render */

    return (
        <Modal motionPreset="slideInBottom" size={"xl"} isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text color={colors.blue} fontSize="lg" fontWeight="bold">🔑 키워드 등록</Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody paddingTop={5}>
                    <FormControl>
                        <FormLabel fontSize="xs" color={colors.blue}>
                            키워드 등록
                        </FormLabel>
                        <Input 
                            {...register("keyword", { required: true, minLength: 1, maxLength: 20 })}
                            type="text" 
                            placeholder="키워드 입력"
                        />
                        {errors.keyword?.message ? <Text fontSize={12} color={colors.red} padding={2}>{errors.keyword?.message}</Text> : null}
                        <Text fontSize={12} color={colors.g3} padding={2}>1자 이상 20자 이하로 입력해주세요.</Text>
                    </FormControl>
                    <Stack marginTop={5} width={"100%"} padding={3}>
                        <Button 
                            onClick={handleSubmit(onSubmit)}
                            isLoading={createKeywordMutation.isPending}
                            disabled={!isValid}
                            width={"100%"}
                            backgroundColor={colors.blue}
                            color={colors.white}
                            borderRadius={10}
                            _hover={{ bg: colors.blue }}
                            boxShadow="sm"
                        >
                            등록
                        </Button>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
        )
}